import common from './common/social-security.common';
import components from './components/social-security.components';
import features from './features/social-security.features';

let socialsecurityModule = angular.module('social-security', [
  common,
  components,
  features,
])

  .config(($translatePartialLoaderProvider) => {
    'ngInject';

    $translatePartialLoaderProvider.addPart('social-security.module');
  })

  .name;

export default socialsecurityModule;


// WEBPACK FOOTER //
// ./client/app/social-security.module/social-security.module.js